module.exports = __webpack_public_path__ + "img/logo-light.94dbe5d6.svg";